<template>
  <div class="ds-control teas-home-top-info-view" :style="swipeBoxStyle">
    <div class="teas-home-top-info-view-bg">
      <div class="topinfo-div">
        <van-image class="headerimg" fit="cover" :src="data.photo | imgFormat">
          <template v-slot:error>
            <van-image
              class="headerimg"
              fit="cover"
              :src="defaultImg | imgFormat"
            ></van-image>
          </template>
        </van-image>
        <div class="name">{{ data.name || "" }}</div>
      </div>
      <div class="middleinfo-div">
        <van-notice-bar class="classname" :text="data.className || '暂无'" />
        <img
          class="exchangeimg"
          src="../../assets/themes/img/icon_exchange.png"
          alt=""
          @click="jumpExchangeClassPage"
        />
      </div>
      <div class="bottominfo-div">
        {{ data.trainStartDate || "" }} 至 {{ data.trainEndDate || "" }} 共{{
          data.dayNum || 0
        }}天
      </div>
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfMobileTeasHomeTopInfoView",
  mixins: [$mixins.control],
  ctrlCaption: "首页个人信息",
  props: {
    height: {
      type: String,
      default: "150px",
    },
    url: {
      type: String,
      default: "/classes/student/findStudentBaseInfo",
    },
    borderRadius: {
      type: [String, Number],
      default: "10px",
    },
    toUrl: {
      type: String,
      default: "/mobile/teas/teasandncineintegration/mobile-classSwitch",
    },
  },
  computed: {
    swipeBoxStyle() {
      return {
        borderRadius: this.pxToRem(this.borderRadius),
        height: this.pxToRem(this.height),
      };
    },
  },
  data() {
    return {
      data: {},
      defaultImg: dsf.config.setting_public_user_default_header,
    };
  },
  created() {
    if (this.isDesign) {
      this.data = {};
    } else {
      this.reloadData();
    }
  },
  methods: {
    reloadData() {
      if (this.url.length == 0) {
        return;
      }
      let url = this.$replace(this.url, this);
      this.$http
        .get(url)
        .done((res) => {
          if (res.success && res.state == 20000) {
            this.data = res.data || {};
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        });
    },
    jumpExchangeClassPage() {
      let tempUrlString = this.$replace(this.toUrl, this);
      this.$router.push({
        path: tempUrlString,
      });
    },
  },
});
</script>